/**
 * Communities and Associations Data
 * Used in registration forms and profile pages
 */

export const ASSOCIATIONS = [
  "Kenya Private Sector Alliance (KEPSA)",
  "Kenya National Chamber of Commerce and Industry (KNCCI)",
  "Kenya Association of Manufacturers (KAM)",
  "Federation of Kenya Employers (FKE)",
  "Agriculture Sector Network (ASNET)",
  "Association of Startup and SMEs Enablers of Kenya (ASSEK)",
  "American Chamber of Commerce, Kenya",
  "British Chamber of Commerce Kenya (BCCK)",
  "Indian Chamber of Commerce in Kenya",
  "Kenya Israel Chamber of Commerce",
  "Dubai Chamber of Commerce (Kenya operations)",
  "Eastern Africa Association",
  "Kenya Institute of Management (KIM)",
  "Chartered Institute of Marketing (CIM) - Kenya",
  "Association of Professional Societies in East Africa (APSEA)",
  "United Asian Network (UAN)",
  "United Business Network (UBA)",
  "India Kenya Business Council (IKBC)",
  "The Blue Company"
];

export const COMMUNITIES = [
  "BAPS",
  "Hindu Council of Kenya (HCK)",
  "Mombasa Indian Association",
  "British East Africa Indian Association",
  "Indian Chamber of Commerce in Kenya",
  "Bharatwallah Alumni Association",
  "Muslim Association (Sunni)",
  "Ismaili Aga Khanis Association",
  "Bilal Muslim Mission of Kenya",
  "Islamic Foundation",
  "East African Muslim Welfare Association",
  "Supreme Council of Kenya Muslims",
  "Bohra Community Organizations",
  "Ithnasheri Community Organizations",
  "Lohana Community Associations",
  "Patel Brotherhood/Community Associations",
  "Cutchi Gujarati Hindu Union",
  "Arya Samaj",
  "Brahma Samaj",
  "Navnat Vanik Mahajan (Jain)",
  "Visa Oshwal Community (Jain)",
  "Prajapati Community Organizations",
  "Rajput Community Organizations",
  "Vanza Community Organizations",
  "South Indian Community Associations",
  "Sikh Gurdwaras (including Singh Sabha, Ramgarhia Sikh Sabha)",
  "Lions Club (Indian-founded)",
  "Aga Khan Foundation Kenya",
  "Aga Khan Development Network (AKDN) Kenya"
];

// Combined list for dropdown (with type indicator)
export const ALL_OPTIONS = [
  ...ASSOCIATIONS.map(name => ({ name, type: 'association' })),
  ...COMMUNITIES.map(name => ({ name, type: 'community' }))
];

// Countries list (commonly used countries)
export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia",
  "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
  "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei",
  "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde",
  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
  "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
  "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "North Korea", "South Korea",
  "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya",
  "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives",
  "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
  "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
  "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway",
  "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines",
  "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis",
  "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Saudi Arabia",
  "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
  "Solomon Islands", "Somalia", "South Africa", "South Sudan", "Spain", "Sri Lanka", "Sudan",
  "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania",
  "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
  "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
  "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen",
  "Zambia", "Zimbabwe"
];
